export default "__VITE_ASSET__COAiVlQd__"